import { CadenaHorizontal, CadenaVertical } from "./CadenaChart";

export const CadenaBlock = ({ cadena, cambios, testid = "cadena-block" }) => (
  <div data-testid={testid}>
    <h3 className="font-display text-lg font-bold text-gray-900 mb-4">Tu cadena del talento</h3>
    <div className="hidden sm:block"><CadenaHorizontal cadena={cadena} cambios={cambios} /></div>
    <div className="sm:hidden"><CadenaVertical cadena={cadena} cambios={cambios} /></div>
    <div className="mt-4 space-y-2 text-sm text-gray-800">
      {cadena.frase_debil && <p className="font-semibold" data-testid="cadena-frase-debil">{cadena.frase_debil}</p>}
      {cadena.patron && (
        <div data-testid="cadena-patron">
          <p className="font-display font-bold text-[#0b3d2e]" data-testid="cadena-patron-nombre">{cadena.patron.nombre}</p>
          <p className="mt-1 leading-relaxed">{cadena.patron.texto}</p>
        </div>
      )}
      <p className="text-[11px] text-gray-500 pt-1" data-testid="cadena-pie">{cadena.pie}</p>
    </div>
  </div>
);
